import { Select } from 'antd';

import { formatCreditsShort } from '../shared/billing-format';
import { formatDiscountedUsd } from '../shared/discount';

import type { GetBillingPlanTiersResponseDtoTiersItem } from '../../../api/generated/model/getBillingPlanTiersResponseDtoTiersItem';

export type PlanTier = GetBillingPlanTiersResponseDtoTiersItem;

type Props = {
  tiers: PlanTier[];
  value: string | undefined;
  onChange: (priceId: string) => void;
  disabled?: boolean;
  loading?: boolean;
  testId?: string;
};

/** The plans for sale, cheapest first: "400k credits a month · $399". */
export const PlanSelect = ({ tiers, value, onChange, disabled, loading, testId }: Props) => (
  <Select
    value={value}
    onChange={onChange}
    disabled={disabled}
    loading={loading}
    data-testid={testId}
    style={{ width: '100%' }}
    // Keeps a click on the select inside a clickable card from also selecting the card.
    onClick={(event) => event.stopPropagation()}
    options={tiers.map((tier) => ({
      value: tier.priceId,
      label: `${formatCreditsShort(tier.credits)} credits a month · ${formatDiscountedUsd(tier.amountCents, tier.discountedAmountCents)}`,
    }))}
  />
);
